var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item){return _c(_vm.resolveNavItemComponent(item),{key:item.route || item.title,tag:"component",attrs:{"data-test":item.route,"item":item}},[_vm._v(" "+_vm._s(_vm.$t(item.title))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }